import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWall from '../components/Frontend/FameWall';
import Testimonial from '../components/Frontend/Testimonial';
import VideoTuts from '../components/Frontend/VideoTuts';
import WhyLove from '../components/Frontend/WhyLove';
import { Link} from 'react-router-dom';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import Slider from "react-slick";
class PteMockTest extends React.Component {
    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        
        ReactPixel.init('197333187452630');
        // ReactPixel.pageView();
    }
    constructor(props) {
      super(props);
      this.state = {
        isActive: false,
      };
    }
    handleClick = () => {
      this.setState((prevState) => ({
        isActive: !prevState.isActive,
      }));
    };   

 render(){   
   const customslider = {      
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };

    return (
    <React.Fragment>
    <Header />
         <div className="hero-section mt-80">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 col-md-8">
                <div className="hero-content">
                  <h1 className="mfw-600 primary-heading dark-blue-color">
                  Maximize your exam score with the Best PTE tutorials and practice test
                  </h1>
                  <p className="sub-heading">
                  Practice regularly with the Pearson PTE mock test online and be ready to ace the exam
                  </p>
                  <div className="text-center text-md-start">
                    <Link to="/auth/register" className="primary-btn">
                      REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="hero-img-wrapper">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/hero_img.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>     
         <div className="pte-content-section pt-0">
            <div className="circle-section">
               <div className="container pte-container">
                  <div className="row">
                  <div className="col-md-12">                         
                     <div className="position-relative">
                        <ul className="m-0">
                        <li>                       
                        PTE exam has become quite popular among the candidates who want to study abroad or permanently settle in a foreign (English speaking) country. When it comes to the PTE academic preparation, we find the aspirants always searching for the best study and practice material to crack the exam with flying colors. But, to nail the exam, what matters the most is how much practice one has done using the PTE academic mock test. More the number of practice tests you attempt, the more are the chances to get success in the final paper.
                        </li>
                        <li>The PTE mock exam sets play a crucial role when it comes to achieving your target score in the actual examination. These provide a real-time test environment to the candidates and help them deal with their fears associated with facing the actual exam. Apart from working as a confidence booster, such PTE exam mock test sets also help to understand the paper pattern thoroughly. </li>                              
                        </ul>
                        <img
                        className="emoji-img"
                        src="/images/web-new-images/emojis/smile-icon.png"
                        alt="LA"
                        />
                     </div>
                     <div
                        className="pte-bottom-content"             
                     >
                        <div>
                        <div onClick={this.handleClick} className="pte-bottom-header d-flex justify-content-center align-items-center">
                              <h3 className="m-0">
                                 <a href="javascript:void(0)" className='text-decoration-none'>Read more</a>
                              </h3>
                              <img
                              src="/images/web-new-images/icons/bottom-arrow-01.png"
                              alt="LA"
                              />
                        </div>
                        <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}> 
                           <li> Do you also want to master your preparation by practicing the best Pearson PTE mock test online? Confused about who can provide you the top-notch coaching and PTE academic practice test material on which you can rely altogether?  Contact our experts over a call on <a href="tel:+61426230061" target="blank">+61 426230061</a> or via mail at <a href='mailto:info@languageacademy.com.au'>info@languageacademy.com.au</a> and get ready to excel in the exam with a perfect package of PTE tutorials, study material, and mock tests.</li>
                        </ul>
                        </div>
                     </div>
                     <div className="text-center">
                        <Link to="/auth/register" className="primary-btn">
                        REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                        </Link>
                     </div>
                  </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="landing-cards-section pmt-cards">
            <div className="container">
            <div className="landing-cards">
               <div className="landing-card card1 position-relative">
                  <Link to="/pte-listening"></Link>
                  <div className="img-wrapper">
                  <img src="/images/web-new-images/icons/01.svg" alt="LA" />
                  </div>
                  <h2 className="card-title">
                  Listening
                  </h2>
                  <p className="card-sub-title">
                  Start preparing for the listening section using the latest practice material.
                  </p>
               </div>
               <div className="landing-card card2 position-relative">
                  <Link to="/pte-writing" ></Link>
                  <div className="img-wrapper">
                  <img src="/images/web-new-images/icons/02.svg" alt="LA" />
                  </div>
                  <h2 className="card-title">
                  Writing
                  </h2>
                  <p className="card-sub-title">
                  Sharpen your writing skills with the best PTE writing practice material.
                  </p>
               </div>
               <div className="landing-card card3 position-relative">
                  <Link to="/pte-reading"></Link>
                  <div className="img-wrapper">
                  <img src="/images/web-new-images/icons/03.svg" alt="LA" />
                  </div>
                  <h2 className="card-title">
                  Reading
                  </h2>
                  <p className="card-sub-title">
                  Get the intensive PTE reading practice material to skyrocket your score.
                  </p>
               </div>
               <div className="landing-card card4 position-relative">
                  <Link to="/pte-speaking"></Link>
                  <div className="img-wrapper">
                  <img src="/images/web-new-images/icons/04.svg" alt="LA" />
                  </div>
                  <h2 className="card-title">
                  Speaking
                  </h2>
                  <p className="card-sub-title">
                  Get the guidance from our experts and remove all the hurdles that you face in PTE speaking test module.
                  </p>
               </div>
            </div>
            <div className="d-flex justify-content-center">
               <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                  REGISTER NOW
                  <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                  </span>
               </Link>
            </div>
            </div>
         </div>
    <WhyLove />
    <Testimonial />
    <Footer />
    </React.Fragment>);
    }
}

export default PteMockTest;